
import { all_routes } from "../../../feature-module/router/all_routes";
interface SidebarItem {
  label: string;
  icon?: string;
  submenu?: boolean;
  submenuOpen?: boolean;
  showSubRoute?: boolean;
  submenuHdr?: string;
  link?: string;
  subLink1?: string;
  subLink2?: string;
  subLink3?: string;
  subLink4?: string;
  roles?: string[];
  submenuItems?: SidebarItem[];
}

const route = all_routes;
export const SidebarData: SidebarItem[] = [
  {
    label: "MAIN MENU",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Main",
    roles: ["admin", "user"],
    submenuItems: [
      {
        label: "Dashboard",
        icon: "ti ti-layout-2",
        showSubRoute: false,
        roles: ["user"],
        link: route.leadsDashboard,
      },

      {
        label: "Dashboard",
        icon: "ti ti-user-star",
        submenu: false,
        showSubRoute: false,
        link: route.dealsDashboard,
        roles: ["admin"],
      },
       {
        label: "Employee Dashboard",
        icon: "ti ti-users",
        submenu: false,
        showSubRoute: false,
        link: route.employeeDashboard,
        roles: ["admin"],
      },
      {
        label: "Dashboard",
        icon: "ti ti-user-star",
        submenu: false,
        showSubRoute: false,
        link: route.superadminDashboard,
        roles: ["superadmin"],
      },
    ],
  } , 
 {
  label: "",
  submenuOpen: true,
  showSubRoute: false,
  submenuHdr: "Inventory",
  roles: ["superadmin"],
  submenuItems: [

          // {
          //   label: "Leads Dashboard",
          //   icon: "ti ti-layout-2",
          //   showSubRoute: false,
          //   roles: ["superadmin"],
          //   link: route.leadsDashboard,
          // },
    
          // {
          //   label: "Deals Dashboard",
          //   icon: "ti ti-user-star",
          //   submenu: false,
          //   showSubRoute: false,
          //   link: route.dealsDashboard,
          //   roles: ["superadmin"],
          // },
          {
            label: "Clients",
            icon: "bi bi-buildings",
            link: route.superadminCompany,
            showSubRoute: false,
            roles: ["superadmin"],
          },
          {
            label: "Subscription",
            icon: "bi bi-cart-check",
            link: route.superadminSubscription,
            showSubRoute: false,
            roles: ["superadmin"],
          },
          {
        label: "Client payment",
        icon: "ti ti-report-money",
        link: route.superadminPayment,
        showSubRoute: false,
        roles: ["superadmin", ],
         },
          {
            label: "Packages",
            icon: "bi bi-card-list",
            link: route.superadminPackagelist,
            showSubRoute: false,
            roles: ["superadmin"],
          },
          // {
          //   label: "Domain",
          //   icon: "ti ti-layout-2",
          //   link: route.superadminDomain,
          //   showSubRoute: false,
          // },
          // {
          //   label: "Purchase Transaction",
          //   icon: "ti ti-layout-2",
          //   link: route.superadminPurchaseTransaction,
          //   showSubRoute: false,
          // },
          // {
          //   label: "Manger User",
          //   icon: "ti ti-layout-2",
          //   link: route.manageusers,
          //   showSubRoute: false,
          // },
          {
            label: "Manage Users",
            link: route.manageusers,
            icon: "bi bi-person-gear",
            showSubRoute: false,
            submenu: false,
            roles: ["superadmin"],
          },
        ],
      },
  {
    label: "CRM Sales",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Inventory",
    roles: [ "admin", "user"],
    submenuItems: [
      {
        label: "Contacts",
        link: route.contactList,
        subLink1: route.contactGrid,
        subLink2: route.contactDetails,
        icon: "ti ti-user-up",
        showSubRoute: false,
        submenu: false,
        roles: ["admin", "user"],
      },
      {
        label: "Leads",
        link: route.leads,
        subLink1: route.leadsDetails,
        subLink2: route.leadsKanban,
        icon: "ti ti-chart-arcs",
        showSubRoute: false,
        submenu: false,
        roles: ["admin", "user"],
      },
            {
        label: "Quotes",
        link: route.ProposalsList,
        subLink1: route.ProposalsView,
        subLink2: route.ProposalsGrid,
        icon: "ti ti-file-star",
        showSubRoute: false,
        submenu: false,
        roles: ["admin", "user"],
      },
      {
        label: "Deals",
        link: route.deals,
        subLink1: route.dealsKanban,
        subLink2: route.dealsDetails,
        icon: "ti ti-medal",
        showSubRoute: false,
        submenu: false,
        roles: ["admin", "user"],
      },
      {
        label: "Invoices",
        link: route.InvoiceList,
        subLink1: route.InvoiceGrid,
        icon: "ti ti-file-invoice",
        showSubRoute: false,
        submenu: false,
        roles: ["admin", "user"],
      },
      {
        label: "Activities",
        link: route.activities,
        // subLink1: route.activityMeeting,
        // subLink2: route.activityTask,
        // subLink3: route.activityMail,
        // subLink4: route.activityCalls,
        icon: "ti ti-bounce-right",
        showSubRoute: false,
        submenu: false,
        roles: ["admin", "user"],
      },
      // {
      //   label: "Pipeline",
      //   link: route.pipeline,
      //   icon: "ti ti-timeline-event-exclamation",
      //   showSubRoute: false,
      //   submenu: false,
      //   roles: ["superadmin", "admin", "user"],
      // },
      // {
      //   label: "Campaign",
      //   link: route.campaign,
      //   subLink1: route.campaignArchieve,
      //   subLink2: route.campaignComplete,
      //   icon: "ti ti-brand-campaignmonitor",
      //   showSubRoute: false,
      //   submenu: false,
      //   roles: ["admin", "user"],
      // },

      // {
      //   label: "Companies",
      //   link: route.companies,
      //   subLink1: route.companyDetails,
      //   subLink2: route.companiesGrid,
      //   icon: "ti ti-building-community",
      //   showSubRoute: false,
      //   submenu: false,
      //   roles: ["superadmin","admin", "user"],
      // },
      // {
      //   label: "Companies",
      //   link: route.superadminCompany,
      //   subLink1: route.companyDetails,
      //   subLink2: route.companiesGrid,
      //   showSubRoute: false,
      //   icon: "ti ti-building-community",
      //   roles: ["superadmin", "admin"],
      // },
      // {
      //   label: "Projects",
      //   link: route.projects,
      //   subLink1: route.projectsGrid,
      //   icon: "ti ti-atom-2",
      //   showSubRoute: false,
      //   submenu: false,
      //   roles: ["superadmin", "admin", "user"],
      // },

      // {
      //   label: "Call Log",
      //   link: route.callSettings,
      //   icon: "ti ti-phone-call",
      //   showSubRoute: false,
      // },
      //       {
      //   label:"Call Page",
      //   link:route.callpage,
      //   icon: "ti ti-brand-whatsapp",
      //   roles: ["admin"],
      //   showSubRoute: false,
      // },

    ],
  },
  {
    label: "Application",
    icon: "ti ti-brand-airtable",
    submenu: true,
    showSubRoute: false,
    roles: ["superadmin", "admin", "user"],
    submenuItems: [ 
      {
        label: "Calendar",
        link: route.calendar,
        icon: "ti ti-calendar",
        showSubRoute: false,
        roles: ["admin", "user"],
      },
      {
        label: "ToDo",
        link: route.todo,
        subLink1: route.tasksCompleted,
        subLink2: route.tasksImportant,
        icon: "bi bi-card-checklist",
        showSubRoute: false,
        submenu: false,
        roles: ["admin", "user"],
      },
      {
        label: "Notes",
        link: route.notes,
        icon: "bi bi-journal-bookmark",
        showSubRoute: false,
        submenu: false,
        roles: ["admin", "user"],
      },
    ],
  },
  // {
  //   label: "Sales",
  //   submenuOpen: true,
  //   showSubRoute: false,
  //   submenuHdr: "Sales",
  //   roles: ["admin", "user"],
  //   submenuItems: [
  //     {
  //       label: "Quotes",
  //       link: route.ProposalsList,
  //       subLink1: route.ProposalsView,
  //       subLink2: route.ProposalsGrid,
  //       icon: "ti ti-file-star",
  //       showSubRoute: false,
  //       submenu: false,
  //       roles: ["admin", "user"],
  //     },
  //     // {
  //     //   label: "Contracts",
  //     //   link: route.ContractsList,
  //     //   subLink1: route.ContractsGrid,
  //     //   icon: "ti ti-file-check",
  //     //   showSubRoute: false,
  //     //   submenu: false,
  //     //   roles: ["superadmin", ],
  //     // },

  //     // {
  //     //   label: "Estimations",
  //     //   link: route.estimationList,
  //     //   subLink1: route.estimationKanban,
  //     //   icon: "ti ti-file-report",
  //     //   showSubRoute: false,
  //     //   submenu: false,
  //     //   roles: ["superadmin", "admin", ],
  //     // },
  //     {
  //       label: "Invoices",
  //       link: route.InvoiceList,
  //       subLink1: route.InvoiceGrid,
  //       icon: "ti ti-file-invoice",
  //       showSubRoute: false,
  //       submenu: false,
  //       roles: ["admin", "user"],
  //     },
  //     // {
  //     //   label: "Payments",
  //     //   link: route.payments,
  //     //   icon: "ti ti-report-money",
  //     //   showSubRoute: false,
  //     //   submenu: false,
  //     //   roles: ["superadmin", "admin", ],
  //     // },
  //     // {
  //     //   label: "Analytics",
  //     //   link: route.analytics,
  //     //   icon: "ti ti-chart-bar",
  //     //   showSubRoute: false,
  //     //   submenu: false,
  //     //   roles: ["admin", "user"],
  //     // },
  //     {
  //       label: "Activities",
  //       link: route.activities,
  //       // subLink1: route.activityMeeting,
  //       // subLink2: route.activityTask,
  //       // subLink3: route.activityMail,
  //       // subLink4: route.activityCalls,
  //       icon: "ti ti-bounce-right",
  //       showSubRoute: false,
  //       submenu: false,
  //       roles: ["admin", "user"],
  //     },
  //   ],
  // },

  {
    label: "Templates",
    submenuOpen: true,
    submenuHdr: "Purchases",
    showSubRoute: false,
    roles: ["superadmin", "admin", "user"],
    submenuItems: [
      {
        label: "Content Messages",
        link: route.contactMessages,
        icon: "ti ti-page-break",
        showSubRoute: false,
        submenu: false,
        roles: ["admin", "user"],
      },
      // {
      //   label: "Tickets",
      //   link: route.tickets,
      //   icon: "ti ti-ticket",
      //   showSubRoute: false,
      //   submenu: false,
      //   roles: ["superadmin", "admin", "user"],
      // },
    ],
  },
  {
    label: "Integration",
    submenu: true,
    showSubRoute: false,
    icon: "ti ti-device-laptop",
    roles: ["admin"],
    submenuItems: [
      {
        label: "Email",
        link: route.emailSettings,
        icon: "ti ti-mail",
        roles: ["admin"],
        showSubRoute: false,
      },
      {
        label: "SMS Gateways",
        link: route.smsGateways,
        icon: "ti ti-device-mobile-message",
        roles: ["admin"],
        showSubRoute: false,
      },
      {
        label: "WhatsApp",
        link: route.WhatsAppSettings,
        icon: "ti ti-brand-whatsapp",
        roles: ["admin"],
        showSubRoute: false,
      },
      {
        label: "Meta",
        link: route.metaSettings,
        icon: "ti ti-brand-meta",
        roles: ["admin"],
        showSubRoute: false,
      },
    ],
  },
  {
  label: "REPORTS",
  submenuOpen: true,
  showSubRoute: false,
  submenuHdr: "Finance & Accounts",
  roles: ["admin"],
  submenuItems: [
    {
      label: "Reports",
      submenu: true,
      submenuOpen: false, 
      showSubRoute: false,
      icon: "ti ti-file-invoice",
      roles: ["admin"],
      submenuItems: [
        {
          label: "Lead Reports",
          link: route.leadReports,
          roles: ["admin"],
          showSubRoute: false,
          icon: "ti ti-chart-pie",
        },
        {
          label: "Deal Reports",
          link: route.dealReports,
          roles: ["admin"],
          showSubRoute: false,
          icon: "ti ti-file-invoice",
        },
        {
          label: "User Reports",
          link: route.companyReports,
          roles: ["admin"],
          showSubRoute: false,
          icon: "ti ti-users",
        },
    // Uncomment if needed
    // {
    //   label: "Contact Reports",
    //   link: route.contactReports,
    //   roles: ["admin", "user"],
    //   showSubRoute: false,
    //   icon: "ti ti-address-book" // example icon
    // },
    // {
    //   label: "Task Reports",
    //   link: route.taskReports,
    //   roles: ["superadmin", "admin", "user"],
    //   showSubRoute: false,
    //   icon: "ti ti-checklist" // example icon
    // }
  ],
},
    ],
  },
  // {
  //   label: "CRM SETTINGS",
  //   submenuOpen: true,
  //   submenuHdr: "Sales",
  //   submenu: false,
  //   showSubRoute: false,
  //   roles: ["superadmin", "admin", "user"],
  //   submenuItems: [
  //     {
  //       label: "Sources",
  //       link: route.sources,
  //       icon: "ti ti-artboard",
  //       showSubRoute: false,
  //       submenu: false,
  //       roles: ["superadmin", "admin", "user"],
  //     },
  //     {
  //       label: "Lost Reason",
  //       link: route.lostReason,
  //       icon: "ti ti-message-exclamation",
  //       showSubRoute: false,
  //       submenu: false,
  //       roles: ["superadmin", "admin", "user"],
  //     },
  //     {
  //       label: "Contact Stage",
  //       link: route.contactStage,
  //       icon: "ti ti-steam",
  //       showSubRoute: false,
  //       submenu: false,
  //       roles: ["superadmin", "admin", ],
  //     },
  //     {
  //       label: "Industry",
  //       link: route.industry,
  //       icon: "ti ti-building-factory",
  //       showSubRoute: false,
  //       submenu: false,
  //       roles: ["superadmin", ],
  //     },
  //     {
  //       label: "Calls",
  //       link: route.calls,
  //       icon: "ti ti-phone-check",
  //       showSubRoute: false,
  //       submenu: false,
  //       roles: ["superadmin", ],
  //     },
  //   ],

  // },

  {
    label: "Settings",
    submenuOpen: true,
    submenuHdr: "Sales",
    submenu: false,
    showSubRoute: false,
    roles: ["admin"],
    submenuItems: [
      // {
      //   label: "Manage Users",
      //   link: route.manageusers,
      //   icon: "ti ti-file-invoice",
      //   showSubRoute: false,
      //   submenu: false,
      //   roles: ["superadmin", "admin"],
      // },
      // { 
      //   label: "Roles & Permission",
      //   // link: route.rolesPermissions,
      //   icon: "ti ti-navigation-cog",
      //   // showSubRoute: false,
      //   // submenu: false,
      //   roles: ["admin", ],
      // },
      // {
      //   label: "Calls",
      //   // link: route.calls,
      //   icon: "ti ti-phone-check",
      //   showSubRoute: false,
      //   submenu: false,
      // },
      {
        label: "Lead Source",
        link: route.leadsource,
        icon: "bi bi-database",
        showSubRoute: false,
        submenu: false,
        roles: ["admin"],
      },
      {
        label: "Lead Given By",
        link: route.leadgivenby,
        icon: "bi bi-person-lines-fill",
        showSubRoute: false,
        submenu: false,
        roles: ["admin"],
      },
      {
        label: "Leads Business Type",
        link: route.LeadsIndustry,
        icon: "ti ti-file-invoice",
        showSubRoute: false,
        submenu: false,
        roles: ["admin" ],
      },
      {
        label: "Lead Stage",
        link: route.LeadsStage,
        icon: "bi bi-boxes",
        showSubRoute: false,
        submenu: false,
        roles: ["admin"],
      },
      {
        label: "Lead Type",
        link: route.LeadsType,
        icon: "bi bi-sticky",
        showSubRoute: false,
        submenu: false,
        roles: ["admin"],
      },
      {
        label: "Products",
        link: route.Products,
        icon: "bi bi-box-seam",
        showSubRoute: false,
        submenu: false,
        roles: ["admin"],
      },
      {
        label: "Product Type",
        link: route.Producttype,
        icon: "bi bi-box2",
        showSubRoute: false,
        submenu: false,
        roles: ["admin"],
      },
      {
        label: "Customer Potential",
        link: route.CustomerPotentialPage,
        icon: "bi bi-bar-chart-line",
        showSubRoute: false,
        submenu: false,
        roles: ["admin"],
      },
      {
        label:"Deal Source",
        link: route.DealsSource,
        icon: "bi bi-globe",
        showSubRoute: false,
        roles: ["admin"],
      },
      {
        label:"Target",
        link: route.Target,
        icon: "bi bi-bullseye",
        showSubRoute: false,
        roles: ["admin"],
      },
      // {
      //   label: "Delete  Request",
      //   link: route.deleteRequest,
      //   icon: "ti ti-flag-question",
      //   showSubRoute: false,
      //   submenu: false,
      //   roles: ["superadmin", "admin"],
      // },
    ],
  },

  // {
  //   label: "General Settings",
  //   submenu: true,
  //   showSubRoute: false,
  //   icon: "ti ti-settings-cog",
  //   submenuItems: [
  //     { label: "Profile", link: route.profile },
  //     { label: "Security", link: route.security },
  //     { label: "Notifications", link: route.notification },
  //     { label: "Connected Apps", link: route.connectedApps },
  //   ],
  // },
  // {
  //   label: "Website Settings",
  //   submenu: true,
  //   showSubRoute: false,
  //   icon: "ti ti-world-cog",
  //   submenuItems: [
  //     {
  //       label: "Company Settings",
  //       link: route.companySettings,
  //       showSubRoute: false,
  //     },
  //     {
  //       label: "Localization",
  //       link: route.localization,
  //       showSubRoute: false,
  //     },
  //     { label: "Prefixes", link: route.prefixes, showSubRoute: false },
  //     { label: "Preference", link: route.preference, showSubRoute: false },
  //     { label: "Appearance", link: route.appearance, showSubRoute: false },
  //     {
  //       label: "Language",
  //       link: route.language,
  //       showSubRoute: false,
  //     },
  //   ],
  // },
  // {
  //   label: "App Settings",
  //   submenu: true,
  //   showSubRoute: false,
  //   icon: "ti ti-apps",
  //   submenuItems: [
  //     {
  //       label: "Invoice",
  //       link: route.invoiceSettings,
  //       showSubRoute: false,
  //     },
  //     { label: "Printer", link: route.printers, showSubRoute: false },
  //     {
  //       label: "Custom Fields",
  //       link: route.customFields,
  //       showSubRoute: false,
  //     },
  //   ],
  // },

  // {
  //   label: "Financial Settings",
  //   submenu: true,
  //   showSubRoute: false,
  //   icon: "ti ti-moneybag",
  //   submenuItems: [
  //     {
  //       label: "Payment Gateway",
  //       link: route.paymentGateways,
  //       showSubRoute: false,
  //     },
  //     {
  //       label: "Bank Accounts",
  //       link: route.bankAccounts,
  //       showSubRoute: false,
  //     },
  //     { label: "Tax Rates", link: route.taxRates, showSubRoute: false },
  //     {
  //       label: "Currencies",
  //       link: route.currencies,
  //       showSubRoute: false,
  //     },
  //   ],
  // },
  // {
  //   label: "Other Settings",
  //   submenu: true,
  //   showSubRoute: false,
  //   icon: "ti ti-flag-cog",
  //   submenuItems: [
  //     { label: "Storage", link: route.storage, showSubRoute: false },
  //     {
  //       label: "Ban IP Address",
  //       link: route.banIpAddrress,
  //       showSubRoute: false,
  //     },
  //   ],
  // },
];
